import { render, staticRenderFns } from "./water-environment.vue?vue&type=template&id=6224d7cb&scoped=true"
import script from "./water-environment.vue?vue&type=script&lang=js"
export * from "./water-environment.vue?vue&type=script&lang=js"
import style0 from "./water-environment.vue?vue&type=style&index=0&id=6224d7cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6224d7cb",
  null
  
)

export default component.exports